import { styled } from '@material-ui/core';
import { CardHeader } from '../../../shared/components';

const AssignmentCardHeader = styled(CardHeader)({
  display: 'flex',
  alignItems: 'center',
  '> *': {
    marginRight: '1rem',

    '&.filter': {
      flex: 1,
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
});

export default AssignmentCardHeader;
